<template>
    <div class="py-3 w-100">
      <div class="text-center">
        <img
          class="logo-img"
          src="/src/assets/images/Logo-removebg-preview.png"
          alt="Logo"
          id="logo"
        />
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' },
      ],
    };
  },
};
</script>

<style scoped>
#logo {
  width: 100%;
  max-width: 30rem;
}
</style>
